export enum TextRendererType {
  Text2dRenderer = 'text_2d_renderer',
  Text3dRenderer = 'text_3d_renderer'
}
